import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const sceneClientRoutes = [
  {
    id: 'scene-view',
    trackingName: 'View Genie Scene',
    path: 'dl/view/scene/:scene_slug',
    loader: async ({ params, context, request }) => {
      const sceneSlug = params['scene_slug']
      const queryString = new URL(request.url).search

      if (!sceneSlug) {
        throw new Error('ViewGenieScene: Missing scene slug')
      }

      context?.browserNavigate(`/account/scene/${sceneSlug}${queryString}`)
    },
  },
] as const satisfies JourneyRoute[]
